// GENERATED FILE, PLEASE DO NOT EDIT
export var BannerHighlightBackground = '#f4f6fe';
export var BannerHighlightIcon = '#2a4de4';
export var ButtonDestructiveBackground = '#EB1700';
export var ButtonDestructiveBackgroundPressed = '#B71000';
export var ButtonDestructiveBackgroundDisabled = '#FDA294';
export var ButtonDestructiveForegroundDisabled = '#ffffff';
export var ButtonFabBackgroundHovered = '#F7F7F7';
export var ButtonFlatPrimaryBackgroundHovered = '#f4f6fe';
export var ButtonFlatPrimaryBackgroundPressed = '#e6ebfd';
export var ButtonFlatPrimaryBackgroundDisabled = '#fafbff';
export var ButtonFlatPrimaryForeground = '#4969f5';
export var ButtonFlatPrimaryForegroundHovered = '#2a4de4';
export var ButtonFlatPrimaryForegroundPressed = '#1537c7';
export var ButtonFlatPrimaryForegroundDisabled = '#b4c2fa';
export var ButtonFlatSecondaryBackgroundHovered = '#F7F7F7';
export var ButtonPrimaryBackground = '#4969f5';
export var ButtonPrimaryBackgroundHovered = '#2a4de4';
export var ButtonPrimaryBackgroundPressed = '#1537c7';
export var ButtonPrimaryBackgroundDisabled = '#b4c2fa';
export var ButtonPrimaryForegroundDisabled = '#fafbff';
export var ButtonPrimaryToggleBackground = '#ffffff';
export var ButtonPrimaryToggleBackgroundDisabled = '#ffffff';
export var ButtonPrimaryToggleBackgroundHovered = '#ffffff';
export var ButtonPrimaryToggleBackgroundPressed = '#ffffff';
export var ButtonPrimaryToggleBackgroundOff = '#ffffff';
export var ButtonPrimaryToggleBackgroundOffDisabled = '#ffffff';
export var ButtonPrimaryToggleBackgroundOffHovered = '#ffffff';
export var ButtonPrimaryToggleBackgroundOffPressed = '#ffffff';
export var ButtonPrimaryToggleBorderOff = '#D6D6D6';
export var ButtonPrimaryToggleBorderOffHovered = '#b4c2fa';
export var ButtonPrimaryToggleBorderOffPressed = '#6c87fb';
export var ButtonPrimaryToggleBorderOn = '#4969f5';
export var ButtonPrimaryToggleBorderOnDisabled = '#b4c2fa';
export var ButtonPrimaryToggleBorderOnHovered = '#4969f5';
export var ButtonPrimaryToggleBorderOnPressed = '#4969f5';
export var ButtonPrimaryToggleForeground = '#4969f5';
export var ButtonPrimaryToggleForegroundDisabled = '#b4c2fa';
export var ButtonPrimaryToggleForegroundHovered = '#4969f5';
export var ButtonPrimaryToggleForegroundPressed = '#4969f5';
export var ButtonSecondaryBackground = '#f4f6fe';
export var ButtonSecondaryBackgroundHovered = '#e6ebfd';
export var ButtonSecondaryBackgroundPressed = '#d1dafb';
export var ButtonSecondaryForeground = '#4969f5';
export var ButtonSecondaryForegroundHovered = '#4969f5';
export var ButtonSecondaryForegroundPressed = '#4969f5';
export var ButtonSecondaryToggleBackground = '#ffffff';
export var ButtonSecondaryToggleBackgroundDisabled = '#ffffff';
export var ButtonSecondaryToggleBackgroundHovered = '#ffffff';
export var ButtonSecondaryToggleBackgroundPressed = '#ffffff';
export var ButtonSecondaryToggleBackgroundOff = '#ffffff';
export var ButtonSecondaryToggleBackgroundOffDisabled = '#ffffff';
export var ButtonSecondaryToggleBackgroundOffHovered = '#ffffff';
export var ButtonSecondaryToggleBackgroundOffPressed = '#ffffff';
export var ButtonSecondaryToggleBorderOff = '#D6D6D6';
export var ButtonSecondaryToggleBorderOffHovered = '#b4c2fa';
export var ButtonSecondaryToggleBorderOffPressed = '#6c87fb';
export var ButtonSecondaryToggleBorderOn = '#4969f5';
export var ButtonSecondaryToggleBorderOnDisabled = '#b4c2fa';
export var ButtonSecondaryToggleBorderOnHovered = '#4969f5';
export var ButtonSecondaryToggleBorderOnPressed = '#4969f5';
export var ButtonSecondaryToggleForeground = '#4969f5';
export var ButtonSecondaryToggleForegroundDisabled = '#b4c2fa';
export var ButtonSecondaryToggleForegroundHovered = '#4969f5';
export var ButtonSecondaryToggleForegroundPressed = '#4969f5';
export var ButtonTertiaryBackground = '#ffffff';
export var ButtonTertiaryBackgroundHovered = '#F7F7F7';
export var ButtonTertiaryBackgroundPressed = '#E7E7E7';
export var ButtonTertiaryBackgroundDisabled = '#ffffff';
export var ButtonTertiaryBorder = '#D6D6D6';
export var ButtonTertiaryBorderDisabled = '#E7E7E7';
export var ButtonTertiaryBorderHovered = '#D6D6D6';
export var ButtonTertiaryBorderPressed = '#C4C4C4';
export var ButtonTertiaryToggleBackground = '#ffffff';
export var ButtonTertiaryToggleBackgroundDisabled = '#C4C4C4';
export var ButtonTertiaryToggleBackgroundHovered = '#E7E7E7';
export var ButtonTertiaryToggleBackgroundPressed = '#D6D6D6';
export var ButtonTertiaryToggleBackgroundOff = '#E7E7E7';
export var ButtonTertiaryToggleBackgroundOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleBackgroundOffHovered = '#D6D6D6';
export var ButtonTertiaryToggleBackgroundOffPressed = '#E7E7E7';
export var ButtonTertiaryToggleBorderOn = '#E7E7E7';
export var ButtonTertiaryToggleBorderOnDisabled = '#C4C4C4';
export var ButtonTertiaryToggleBorderOnHovered = '#606060';
export var ButtonTertiaryToggleBorderOnPressed = '#494949';
export var ButtonTertiaryToggleBorderOff = '#E7E7E7';
export var ButtonTertiaryToggleBorderOffDisabled = '#F7F7F7';
export var ButtonTertiaryToggleBorderOffHovered = '#D6D6D6';
export var ButtonTertiaryToggleBorderOffPressed = '#E7E7E7';
export var ButtonTertiaryToggleForeground = '#4969f5';
export var ButtonTertiaryToggleForegroundDisabled = '#9F9F9F';
export var ButtonTertiaryToggleForegroundHovered = '#4969f5';
export var ButtonTertiaryToggleForegroundPressed = '#4969f5';
export var ButtonTertiaryToggleForegroundOff = '#191919';
export var ButtonTertiaryToggleForegroundOffDisabled = '#B2B2B2';
export var ButtonTertiaryToggleForegroundOffHovered = '#191919';
export var ButtonTertiaryToggleForegroundOffPressed = '#191919';
export var ButtonPrimaryToggleGroupBackgroundOff = '#ffffff';
export var ButtonPrimaryToggleGroupBackgroundOffHovered = '#F7F7F7';
export var ButtonPrimaryToggleGroupBackgroundOffPressed = '#E7E7E7';
export var ButtonPrimaryToggleGroupBackgroundOffDisabled = '#ffffff';
export var ButtonPrimaryToggleGroupBorderOff = '#D6D6D6';
export var ButtonPrimaryToggleGroupBackgroundOn = '#ffffff';
export var ButtonPrimaryToggleGroupBackgroundOnHovered = '#fafbff';
export var ButtonPrimaryToggleGroupBackgroundOnPressed = '#f4f6fe';
export var ButtonPrimaryToggleGroupBackgroundOnDisabled = '#ffffff';
export var ButtonPrimaryToggleGroupBorderOn = '#4969f5';
export var ButtonPrimaryToggleGroupBorderOnHovered = '#4969f5';
export var ButtonPrimaryToggleGroupBorderOnPressed = '#4969f5';
export var ButtonPrimaryToggleGroupBorderOnDisabled = '#b4c2fa';
export var ButtonPrimaryToggleGroupForegroundOn = '#4969f5';
export var ButtonPrimaryToggleGroupForegroundOnHovered = '#4969f5';
export var ButtonPrimaryToggleGroupForegroundOnPressed = '#4969f5';
export var ButtonPrimaryToggleGroupForegroundOnDisabled = '#b4c2fa';
export var ButtonSecondaryToggleGroupBackgroundOff = '#ffffff';
export var ButtonSecondaryToggleGroupBackgroundOffHovered = '#F7F7F7';
export var ButtonSecondaryToggleGroupBackgroundOffPressed = '#E7E7E7';
export var ButtonSecondaryToggleGroupBackgroundOffDisabled = '#ffffff';
export var ButtonSecondaryToggleGroupBorderOff = '#D6D6D6';
export var ButtonSecondaryToggleGroupBackgroundOn = '#ffffff';
export var ButtonSecondaryToggleGroupBackgroundOnHovered = '#fafbff';
export var ButtonSecondaryToggleGroupBackgroundOnPressed = '#f4f6fe';
export var ButtonSecondaryToggleGroupBackgroundOnDisabled = '#ffffff';
export var ButtonSecondaryToggleGroupBorderOn = '#4969f5';
export var ButtonSecondaryToggleGroupBorderOnHovered = '#4969f5';
export var ButtonSecondaryToggleGroupBorderOnPressed = '#4969f5';
export var ButtonSecondaryToggleGroupBorderOnDisabled = '#b4c2fa';
export var ButtonSecondaryToggleGroupForegroundOn = '#4969f5';
export var ButtonSecondaryToggleGroupForegroundOnHovered = '#4969f5';
export var ButtonSecondaryToggleGroupForegroundOnPressed = '#4969f5';
export var ButtonSecondaryToggleGroupForegroundOnDisabled = '#b4c2fa';
export var ButtonTertiaryToggleGroupBackgroundOffHovered = '#F7F7F7';
export var ButtonTertiaryToggleGroupBackgroundOffDisabled = '#ffffff';
export var ButtonTertiaryToggleGroupBorderOff = '#D6D6D6';
export var ButtonTertiaryToggleGroupBorderOffHovered = '#D6D6D6';
export var ButtonTertiaryToggleGroupBorderOffPressed = '#D6D6D6';
export var ButtonTertiaryToggleGroupBackgroundOn = '#ffffff';
export var ButtonTertiaryToggleGroupBackgroundOnHovered = '#fafbff';
export var ButtonTertiaryToggleGroupBackgroundOnPressed = '#f4f6fe';
export var ButtonTertiaryToggleGroupBackgroundOnDisabled = '#ffffff';
export var ButtonTertiaryToggleGroupBorderOn = '#4969f5';
export var ButtonTertiaryToggleGroupBorderOnHovered = '#4969f5';
export var ButtonTertiaryToggleGroupBorderOnPressed = '#4969f5';
export var ButtonTertiaryToggleGroupBorderOnDisabled = '#b4c2fa';
export var ButtonTertiaryToggleGroupForegroundOn = '#4969f5';
export var ButtonTertiaryToggleGroupForegroundOnHovered = '#4969f5';
export var ButtonTertiaryToggleGroupForegroundOnPressed = '#4969f5';
export var ButtonTertiaryToggleGroupForegroundOnDisabled = '#b4c2fa';
export var DatePickerDateUnselectedBackground = '#ffffff';
export var DatePickerDateUnselectedBackgroundHovered = '#D6D6D6';
export var DatePickerDateUnselectedBackgroundPressed = '#C4C4C4';
export var DatePickerDateUnselectedBackgroundDisabled = '#ffffff';
export var DatePickerDateBorderUnselected = '#ffffff';
export var DatePickerDateBorderUnselectedHovered = '#D6D6D6';
export var DatePickerDateBorderUnselectedPressed = '#C4C4C4';
export var DatePickerDateBorderUnselectedDisabled = '#ffffff';
export var DatePickerDateForegroundUnselected = '#191919';
export var DatePickerDateForegroundUnselectedHovered = '#191919';
export var DatePickerDateForegroundUnselectedPressed = '#191919';
export var DatePickerDateForegroundUnselectedDisabled = '#B2B2B2';
export var DatePickerDateSelectedBackground = '#4969f5';
export var DatePickerDateSelectedBackgroundHovered = '#2a4de4';
export var DatePickerDateSelectedBackgroundPressed = '#1537c7';
export var DatePickerDateSelectedBackgroundDisabled = '#b4c2fa';
export var DatePickerDateBorderSelected = '#4969f5';
export var DatePickerDateBorderSelectedHovered = '#2a4de4';
export var DatePickerDateBorderSelectedPressed = '#1537c7';
export var DatePickerDateBorderSelectedDisabled = '#b4c2fa';
export var DatePickerDateForegroundSelected = '#ffffff';
export var DatePickerDateForegroundSelectedHovered = '#ffffff';
export var DatePickerDateForegroundSelectedPressed = '#ffffff';
export var DatePickerDateForegroundSelectedDisabled = '#ffffff';
export var DatePickerRangeUnselectedBackground = '#ffffff';
export var DatePickerRangeUnselectedBackgroundHovered = '#F7F7F7';
export var DatePickerRangeUnselectedBackgroundPressed = '#E7E7E7';
export var DatePickerRangeUnselectedBackgroundDisabled = '#ffffff';
export var DatePickerRangeBorderUnselected = '#ffffff';
export var DatePickerRangeBorderUnselectedHovered = '#F7F7F7';
export var DatePickerRangeBorderUnselectedPressed = '#E7E7E7';
export var DatePickerRangeBorderUnselectedDisabled = '#ffffff';
export var DatePickerRangeForegroundUnselected = '#191919';
export var DatePickerRangeForegroundUnselectedHovered = '#191919';
export var DatePickerRangeForegroundUnselectedPressed = '#191919';
export var DatePickerRangeForegroundUnselectedDisabled = '#B2B2B2';
export var DatePickerRangeSelectedBackground = '#e6ebfd';
export var DatePickerRangeSelectedBackgroundHovered = '#d1dafb';
export var DatePickerRangeSelectedBackgroundPressed = '#b4c2fa';
export var DatePickerRangeSelectedBackgroundDisabled = '#f4f6fe';
export var DatePickerRangeBorderSelected = '#e6ebfd';
export var DatePickerRangeBorderSelectedHovered = '#d1dafb';
export var DatePickerRangeBorderSelectedPressed = '#b4c2fa';
export var DatePickerRangeBorderSelectedDisabled = '#f4f6fe';
export var DatePickerRangeForegroundSelected = '#2a4de4';
export var DatePickerRangeForegroundSelectedHovered = '#2a4de4';
export var DatePickerRangeForegroundSelectedPressed = '#2a4de4';
export var DatePickerRangeForegroundSelectedDisabled = '#b4c2fa';
export var DatePickerTodayBorderSelected = '#191919';
export var FieldsBackgroundActive = '#ffffff';
export var FieldsBackgroundInactive = '#ffffff';
export var FieldsBorderActive = '#91a5f9';
export var FieldsBorderDisabled = '#D6D6D6';
export var FieldsBorderInactive = '#D6D6D6';
export var ListCellIconToggledOn = '#4969f5';
export var LoadingDefault = '#4969f5';
export var OverlayLoadingDefault = '#4969f5';
export var PaginationNumberedNavigationBackground = '#ffffff';
export var PaginationNumberedNavigationBackgroundPressed = '#E7E7E7';
export var PaginationNumberedNavigationBackgroundDisabled = '#ffffff';
export var PaginationNumberedNavigationBorder = '#ffffff';
export var PaginationNumberedNavigationBorderPressed = '#E7E7E7';
export var PaginationNumberedNavigationBorderDisabled = '#ffffff';
export var PaginationNumberedSelectedBackground = '#ffffff';
export var PaginationNumberedSelectedBackgroundDisabled = '#ffffff';
export var PaginationNumberedSelectedBackgroundHovered = '#ffffff';
export var PaginationNumberedSelectedBackgroundPressed = '#ffffff';
export var PaginationNumberedSelectedBorder = '#4969f5';
export var PaginationNumberedSelectedBorderDisabled = '#b4c2fa';
export var PaginationNumberedSelectedBorderHovered = '#4969f5';
export var PaginationNumberedSelectedBorderPressed = '#4969f5';
export var PaginationNumberedSelectedForeground = '#4969f5';
export var PaginationNumberedSelectedForegroundDisabled = '#b4c2fa';
export var PaginationNumberedSelectedForegroundHovered = '#4969f5';
export var PaginationNumberedSelectedForegroundPressed = '#4969f5';
export var PaginationNumberedUnselectedBackground = '#ffffff';
export var PaginationNumberedUnselectedBackgroundDisabled = '#ffffff';
export var PaginationNumberedUnselectedBackgroundHovered = '#ffffff';
export var PaginationNumberedUnselectedBackgroundPressed = '#ffffff';
export var PaginationNumberedUnselectedBorder = '#ffffff';
export var PaginationNumberedUnselectedBorderHovered = '#d1dafb';
export var PaginationNumberedUnselectedBorderPressed = '#b4c2fa';
export var PaginationNumberedUnselectedBorderDisabled = '#ffffff';
export var PaginationSelectedPrimary = '#4969f5';
export var RatingSelected = '#4969f5';
export var SliderKnobBackground = '#4969f5';
export var SliderKnobBackgroundHovered = '#2a4de4';
export var SliderKnobBackgroundPressed = '#1537c7';
export var SliderTrackBackgroundOn = '#4969f5';
export var SwitchBackgroundOn = '#4969f5';
export var SwitchBackgroundOff = '#B2B2B2';
export var SwitchBackgroundOffDisabled = '#E7E7E7';
export var SwitchBorderOn = '#4969f5';
export var SwitchBorderOff = '#B2B2B2';
export var SwitchBorderOffDisabled = '#F7F7F7';
export var SwitchForegroundOnDisabled = '#F7F7F7';
export var SwitchForegroundOffDisabled = '#F7F7F7';
export var TagHighlightBackground = '#4969f5';
export var TagHighlightBorder = '#4969f5';
export var TagHighlightDefaultBackground = '#e6ebfd';
export var TagHighlightDefaultBorder = '#e6ebfd';
export var TagHighlightDefaultForeground = '#2a4de4';
export var TagHighlightDefaultIcon = '#2a4de4';
export var TagHighlightEmphasisBackground = '#4969f5';
export var TagHighlightEmphasisBorder = '#4969f5';
export var TagHighlightEmphasisForeground = '#ffffff';
export var TagHighlightEmphasisIcon = '#ffffff';
export var TagHighlightSubduedBackground = '#ffffff';
export var TagHighlightSubduedBorder = '#D6D6D6';
export var TagHighlightSubduedForeground = '#4969f5';
export var TagHighlightSubduedIcon = '#4969f5';
export var TextAccentedPrimary = '#4969f5';
export var TextAction = '#4969f5';
export var TextCallout = '#4969f5';
export var TextHighlight = '#4969f5';
export var TextSelected = '#4969f5';
export var ToastInformationalBackground = '#ffffff';
export var ToastInformationalForeground = '#191919';
export var ToastInformationalAction = '#4969f5';
export var ToastInformationalActionPressed = '#767676';
export var ToastInformationalActionHovered = '#494949';
export var ToastInformationalActionDisabled = '#B2B2B2';
export var ToggleBackgroundOn = '#4969f5';
export var ToggleBorderOn = '#4969f5';
export var ToggleForegroundOnDisabled = '#ffffff';
export var TooltipHighlightBackground = '#4969f5';
export var TooltipHighlightBackgroundHovered = '#2a4de4';
export var TooltipHighlightBackgroundPressed = '#1537c7';
export var TooltipInformationalBackground = '#ffffff';
export var TooltipInformationalBackgroundHovered = '#F7F7F7';
export var TooltipInformationalBackgroundPressed = '#E7E7E7';
export var TooltipInformationalForeground = '#191919';
export var TooltipInformationalForegroundHovered = '#191919';
export var TooltipInformationalForegroundPressed = '#191919';